module.exports = __webpack_public_path__ + "img/hmg03_samurai01_shop.7f761a94.png";